import type { RootState } from "@/types";
import { createStore } from "vuex";
import { SelfDataModule } from "./self-data";
import { WebSocketModule } from "./web-socket";
import { DataExplorerModule } from "./data-explorer";
import { AlertingModule } from "./alerting";
import { ScenarioModule } from "./scenarios";
import { FormulaModule } from "./formula";
import { RouterModule } from "./router";
import { ParameterModule } from "./parameter";
import { UserModule } from "./user";
import { StatStateModule } from "./stats";
import { ContactModule } from "./contact";
import { DataAnalyticsModule } from "./data-analytics";
import { BexSupportModule } from "./bex-ticket";
import { BexRapportModule } from "./bex-rapport";
import { CpeRapportModule } from "./cpe-rapport";
import { CpeAutoRapportModule } from "./cpe-auto-rapport";

export const rootState: RootState = {};

export default createStore({
  state: rootState,
  mutations: {},
  actions: {},
  modules: {
    selfData: SelfDataModule,
    dataExplorer: DataExplorerModule,
    alerting: AlertingModule,
    bexSupport: BexSupportModule,
    bexRapport: BexRapportModule,
    cpeRapport: CpeRapportModule,
    cpeAutoRapport: CpeAutoRapportModule,
    ws: WebSocketModule,
    scenarios: ScenarioModule,
    formula: FormulaModule,
    router: RouterModule,
    parameter: ParameterModule,
    user: UserModule,
    stat: StatStateModule,
    contact: ContactModule,
    dataAnalytics: DataAnalyticsModule,
  },
});
